/**
 * StyledButtonのIDを定義
 */
const STYLED_BUTTON_ID = {
  SAVE_ESTIMATE: "1clickSaveEstBtn",
  ONE_CLICK_ORDER: "1clickOrderBtn",
} as const

export default STYLED_BUTTON_ID
